import { atom } from 'jotai';
import type { AnyObject } from '../../../../../../types';

// 필터에 사용되는 query parameter 키 값을 고정으로 넣으면, 추후에 필터가 추가가 되면 프론트 작업이 추가로 들어가게 되어서 동적으로 넣어줄 수 있게 하기 위해 [key: string] 사용
// 클라에서도 필터가 추가되도 동적으로 돌아갈 수 있도록 작업이 되어 있어서 클라이언트와 씽크를 맞춤
// 그래도 알 수 있는것들은 적어봅니다..
export type FilterListBottomSheet = AnyObject;

export const filterListBottomSheetAtom = atom<FilterListBottomSheet>({});
